import type { ProviderCodeType } from '@/uTypes/order/api'
import { PROVIDER_CODE } from '@/constants/order'

export const simTypeFormat = (simType: SimType) => {
  if (simType) {
    return simType === 'usim' ? 'USIM' : 'eSIM'
  } else {
    return ''
  }
}

export const providerFormat = (provider: ProviderCodeType) => {
  if (provider) {
    return provider === PROVIDER_CODE.local ? '로컬망' : '로밍망'
  } else {
    return ''
  }
}

// 휴대폰 번호 010-1234-1234 형식으로 변환
export const phoneNumberFormat = (phone: string): string => {
  const onlyNums = phone.replace(/\D/g, '').slice(0, 11)

  if (onlyNums.length < 4) return onlyNums
  if (onlyNums.length < 8) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 7)}-${onlyNums.slice(7)}`
}


// 휴대폰번호 숫자만 남기고 최대 길이 제한 (기본 11자리)
export const phoneDigitsFormat = (value: string, maxLength = 11): string => {
  return value.replace(/\D/g, '').slice(0, maxLength)
}

// 숫자만 남기기
export const digitsOnlyFormat = (value: string): string => {
  return value.replace(/\D/g, '')
}
